// same file as cjs, vite build for matrix-spa is failing to import cjs
// https://github.com/jesstech/postcss-rem-to-pixel/blob/master/lib/rem-unit-regex.js
// Not anything inside double quotes
// Not anything inside single quotes
// Not anything inside url()
// Any digit followed by rem
// !singlequotes|!doublequotes|!url()|remunit
// eslint-disable-next-line -- same as cjs
const REM_REGEX = /"[^"]+"|'[^']+'|url\([^)]+\)|(-?\d*\.?\d+)rem/g;

// Converts rem values to calc(var(--remMultiplier, 1) * value) format
// Eg. 1rem to calc(var(--remMultiplier, 1) * 1rem)
function getAdaptedRemValue(value: string) {
  return value.replace(REM_REGEX, remReplace);
}

function remReplace(match: string, $1: string) {
  if (!$1) return match;
  const remValue = parseFloat($1);

  return `calc(var(--remMultiplier, 1) * ${remValue}rem)`;
}

export default getAdaptedRemValue;
